// copied over from machete for test
const TexturingUtils = {
  /**
   * Takes the data from https://manowar.hover.to/hover_models/manufacturer_products.json
   * and generates a list of products, variations and variations groups
   *     - Product: Timberline HD
   *     - Variation (a color): Red
   *     - Variation Group (group of colors): Reds
   */
  parseProductsAndVariations(manufacturerProductsData) {
    let products;
    let variations;
    let variationGroups;
    let result;
    let stack;
    let index;
    let currentLevel;
    let isPenultimeLevel;
    let isAntiPenultimeLevel;

    /*
     * manufacturerProductsData is a tree structure
     * elements in the last level (leaf nodes): variations (colors)
     * elements in the penultime level:
     *   - if the branch has 2 levels (branch depth == 2): products
     *   - if the branch has 3 or more levels (branch depth > 2): variation group
     * elements in the antipenultime level:
     *  - if the branch has 2 levels (branch depth == 2): Impossible case.
     *  - if the branch has 3 or more levels (branch depth > 2): product
     */
    products = [];
    variations = [];
    variationGroups = [];
    result = {};

    // track execution time

    // shallow copy
    stack = manufacturerProductsData.slice();
    index = 0;

    do {
      // pop
      currentLevel = stack[index++];

      isPenultimeLevel = false;
      isAntiPenultimeLevel = false;

      if (currentLevel.children.length > 0) {
        isPenultimeLevel = currentLevel.children.every(function(nextLevel) {
          return nextLevel.children.length === 0;
        });

        if (!isPenultimeLevel) {
          isAntiPenultimeLevel = currentLevel.children.every(function(
            levelOne,
          ) {
            return levelOne.children.every(function(levelTwo) {
              return levelTwo.children.length === 0;
            });
          });
        }
      }

      if (isPenultimeLevel && isAntiPenultimeLevel) {
        Logger.error("ERROR: both values can't be true. Something is wrong.");
      }

      if (isPenultimeLevel) {
        /*
         * if the product has variations present,
         * add product and variations
         */
        if (currentLevel.children.length > 0) {
          // current level is a product
          products.push(currentLevel);

          // next level contains variations (colors)
          currentLevel.children.forEach(function(variation) {
            variations.push(variation);

            if (
              currentLevel.product_id === null &&
              variation.product_id !== null
            ) {
              currentLevel.product_id = variation.product_id;
            }
          });
        }
      } else if (isAntiPenultimeLevel) {
        // current level is a product
        products.push(currentLevel);

        // next level contains variation_groups
        currentLevel.children.forEach(function(variationGroup) {
          // if the variation group has elements present
          if (variationGroup.children.length > 0) {
            variationGroups.push(variationGroup);

            // last level contains variations (colors)
            variationGroup.children.forEach(function(variation) {
              variations.push(variation);

              if (
                currentLevel.product_id === null &&
                variation.product_id !== null
              ) {
                currentLevel.product_id = variation.product_id;
              }
            });
          }
        });
      } else {
        /*
         * if the current level isn't the penultime nor the antipenultime level,
         * ensure that the we process the data until we get to those levels
         */
        currentLevel.children.forEach(function(child) {
          stack.push(child);
        });
      }
    } while (index < stack.length);

    return {
      products,
      variationGroups,
      variations,
    };
  },
};

export default TexturingUtils;
